import {GetterTree} from "vuex";
import {NavigationWidgetState} from "@/apps/NavigationWidget/model/navigation-widget-state";
import INavigationItem from "@/apps/NavigationWidget/model/navigation-item";


export default <GetterTree<NavigationWidgetState, NavigationWidgetState>>{
    breadCrumb(state) {
        let over = state.storedTree.length - 3;
        return state.storedTree.slice(over > 0 ? over : 0, 3 + over);
    },

    rootItem(state) {
        if (state.storedTree.length === 1) {
            return state.data;
        }
        return state.storedTree[state.storedTree.length - 2];
    },

    firstLevel(state) {
        if (state.storedTree.length > 1) {
            return state.storedTree[state.storedTree.length - 2];
        }
        return state.data;
    },

    getLabels(state) {
        return state.labels;
    },

    renderGoBackTo: (state) => (name: string) => {
        return state.labels.back.replace('{0}', name);
    },

    checkIfActive: (state) => (subItem: INavigationItem) => {
        return state.storedTree.find(item => item === subItem);
    },
}

